import { render, staticRenderFns } from "./HistoryInsertTransactionDetail.vue?vue&type=template&id=05941edb"
import script from "./HistoryInsertTransactionDetail.vue?vue&type=script&lang=js"
export * from "./HistoryInsertTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./HistoryInsertTransactionDetail.vue?vue&type=style&index=0&id=05941edb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports